import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reports-quick-actions',
  template: require('./reports-quick-actions.component.html')
})
export class ReportsQuickActionsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/reports-quick-actions/reports-quick-actions.component.ts